import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('cyberon_language', lng);
  };

  return {
    t,
    currentLanguage: i18n.language,
    changeLanguage,
    languages: [
      { code: 'ca', name: 'Català', flag: '🇪🇸' },
      { code: 'es', name: 'Español', flag: '🇪🇸' },
      { code: 'en', name: 'English', flag: '🇬🇧' },
    ],
  };
};
